import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "showAllUsersOption", "filterUserId", "fetchMeetingsLinks", "setSelectedUserOption", "value", "noResultsText"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import HubSpotUserSelect from '../../editLink/HubSpotUserSelect';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const OwnerSelect = _ref => {
  let {
      disabled,
      showAllUsersOption = false,
      filterUserId,
      fetchMeetingsLinks,
      setSelectedUserOption,
      value,
      noResultsText
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleChange = newValue => {
    setSelectedUserOption(newValue);
    fetchMeetingsLinks(newValue);
  };
  return /*#__PURE__*/_jsx(InlineLabel, Object.assign({}, rest, {
    label:
    /*#__PURE__*/
    // @ts-expect-error No overload matches this call
    _jsx(FormattedMessage, {
      id: "SelectLabel",
      message: "editLink.meetingOwner"
    }),
    children: /*#__PURE__*/_jsx(HubSpotUserSelect, {
      disabled: disabled,
      "data-test-id": "owner-filter",
      "aria-labelledby": "SelectLabel",
      buttonUse: "link",
      filterUserId: filterUserId,
      showAllUsersOption: showAllUsersOption,
      placeholder: I18n.text('editLink.meetingOwnerSearch'),
      noResultsText: noResultsText,
      searchPromptText: noResultsText
      // @ts-expect-error Type 'number | "ALL_MEETINGS_USERS"' is not assignable
      ,
      value: value,
      onChange: handleChange,
      searchPlaceholder: I18n.text('editLink.meetingOwnerSearchPlaceholder'),
      menuWidth: "auto",
      error: undefined,
      valueComponent: undefined
    })
  }));
};
export default OwnerSelect;